import _ from 'lodash';

import SessionUtil from '../../common/util/SessionUtil';

export default ['$filter', 'ModalService', 'qnb.cpCoverablesService', function ($filter, ModalService, CPCoverablesService) {
    return {
        deleteBuilding: function deleteBuilding(model, location, building) {
            var sessionID = SessionUtil.getSessionUUID(model);

            return ModalService.showWarning('quoteandbind.cp.views.cp-building-view.Delete Building', 'quoteandbind.cp.views.cp-building-view.Are you sure you want to delete this building?', null, $filter('translate')('quoteandbind.cp.views.cp-building-view.Yes, please delete'), null, $filter('translate')('quoteandbind.cp.views.cp-building-view.No, Ill keep it')).result.then(function () {
                var jobID = model.quoteID ? model.quoteID.value : model.jobID.value;

                if (location.buildings.length === 1 && !location.isPrimary) {
                    return CPCoverablesService.removeCPLocation(jobID, location, sessionID).then(function () {
                        _.remove(model.lobData.commercialProperty.coverables.locations.value, function (loc) {
                            return loc.publicID === location.publicID;
                        });
                    });
                }

                return CPCoverablesService.removeCPBuilding(jobID, location.publicID, building.publicID, sessionID).then(function () {
                    _.remove(location.buildings, function (bdg) {
                        return bdg.publicID === building.publicID;
                    });
                });
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/cp/services/CPDeleteBuildingService.js
// module id = 2145
// module chunks = 0